var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"material-icons-round md-24",attrs:{"title":_vm.$t('buttons.fullscreen')},on:{"click":function($event){return _vm.toggleFullscreen($event)}}},[_vm._v(" "+_vm._s(_vm.enabled ? "fullscreen_exit" : "fullscreen")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }